export interface StockItemHeaderForPurchaseInvoice {
  id: string;
  purchaseOrderAndLineNo: string;
  supplierKey: string;
  supplierName: string;
  deliveryNoteNo: string;
  externalNo: string;
  stockNo: string;
  productKey: string;
  productDescription: string;
  qtyIn: number;
  qtyInImperial: number;
  valueIn: number;
  price: number;
  purchaseInvoiceQty: number;
  purchaseInvoicePrice: number;
  purchaseInvoiceValue: number;
  batchNo: string;
  dateReceived: Date;
  selected: boolean;
  canDelete: boolean;
}
